import styled, { css } from 'styled-components';

import { media } from 'styles/utils';
import { fadeIn } from 'styles/animations';

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  padding: 24px;
  animation: ${fadeIn} 300ms ease-out;

  ${media.tablet<ContentProps>`
    margin: 0 auto;
    padding: 80px 24px;
    max-width: 400px;

    ${({ maxWidthConstrained }) => maxWidthConstrained === false && css`
      max-width: none;
    `}
  `}

  ${({ wide }) => wide && media.tablet`
    max-width: 1040px;
  `};
`;

type ContentProps = {
  maxWidthConstrained?: boolean;
  wide?: boolean;
};
